import { VosBeheerDto } from "@/shared/types";

export type BeheerVos = {
    entraId: string;
    naam?: string;
    email?: string;
    mobielNummer?: string;
    inzetStationcodes: string[];
    inzetStationnamen: string[];
    isActief?: boolean;
    isVosGroepLid?: boolean;
};

export const BeheerVos = {
    fromDto: (dto: VosBeheerDto): BeheerVos => ({
        entraId: dto.entraId,
        naam: dto.naam,
        email: dto.email,
        mobielNummer: dto.mobielNummer,
        inzetStationcodes: dto.inzetStationcodes.map((stationsCode) => stationsCode.toUpperCase()),
        inzetStationnamen: dto.inzetStationnamen,
        isActief: dto.medewerkerActief,
        isVosGroepLid: dto.vosGroepLid,
    }),
    sort: (a: BeheerVos, b: BeheerVos): number => {
        if (a.naam && b.naam) {
            return a.naam.localeCompare(b.naam);
        } else if (a.email && b.email) {
            return a.email.localeCompare(b.email);
        } else {
            return 0;
        }
    },
};
